export default __webpack_public_path__ + "static/media/tip7.94cf62dd.png";